<template>
  <div>
    <div class="mb-3">
      <label for="">{{ 'Header' | translate }}</label>
      <input
        class="form-control"
        type="text"
        v-model="block.header"
        :placeholder="$t('Header')"
        maxlength="200"
      />
    </div>

    <hr />


      <div class="mb-3">
        <ImageUpload
          :file-path="block.file"
          @uploadCompleted="storeFile"
          @fileDeleted="deleteFile"
          context="block.image"
        ></ImageUpload>
      </div>

    <div class="mb-3">
      <QuillInputS
        name="body"
        display-name=""
        placeholder="Body here"
        :value="block.quill"
        @quillChanged="quillChanged"
      ></QuillInputS>
    </div>

    <div>
      <div class="mt-3">
        <label for="facebook_input" class="small">Facebook</label>
        <input v-model="social.facebook" @input="socialChange" type="text" name="facebook" class="form-control" id="facebook_input" placeholder="https://www.facebook.com/username" >
      </div>
      <div class="mt-3">
        <label for="twitter_input" class="small">Twitter</label>
        <input v-model="social.twitter" @input="socialChange" type="text" name="twitter" class="form-control" id="twitter_input" placeholder="https://www.twitter.com/usermane" >
      </div>
      <div class="mt-3">
        <label for="instagram_input" class="small">Instagram</label>
        <input v-model="social.instagram" @input="socialChange" type="text" name="instagram" class="form-control" id="instagram_input" placeholder="https://www.instagram.com/username" >
      </div>
      <div class="mt-3">
        <label for="youtube_input" class="small">YouTube</label>
        <input v-model="social.youtube" @input="socialChange" type="text" name="youtube" class="form-control" id="youtube_input" placeholder="https://www.youtube.com/username" >
      </div>
      <div class="mt-3">
        <label for="pinterest_input" class="small">Pinterest</label>
        <input v-model="social.pinterest" @input="socialChange" type="text" name="pinterest" class="form-control" id="pinterest_input" placeholder="https://www.pinterest.com/username" >
      </div>
      <div class="mt-3">
        <label for="linkedin_input" class="small">LinkedIn</label>
        <input v-model="social.linkedin" @input="socialChange" type="text" name="linkedin" class="form-control" id="linkedin_input" placeholder="https://www.linkedin.com/username" >
      </div>
      <div class="mt-3">
        <label for="tiktok_input" class="small">TikTok</label>
        <input v-model="social.tiktok" @input="socialChange" type="text" name="tiktok" class="form-control" id="tiktok_input" placeholder="https://www.tiktok.com/@username" >
      </div>
    </div>

  </div>
</template>

<script>
import route from './../../routes.js'
import ImageUpload from './../ImageUpload'
import QuillInputS from './../QuillInputS'
import _ from 'lodash'

export default {
  components: {
    ImageUpload,
    QuillInputS,
  },
  props: ['block'],
  data() {
    return {
      social: this.block.data || {},
    }
  },
  mounted() {},
  methods: {
    img(url) {
      if (!url) {
        return false
      }
      return route.image(url)
    },
    deleteFile() {
      this.block.file = null
      this.$emit('fileDeleted')
    },
    storeFile(filePath) {
      this.block.file = filePath
      this.$emit('fileUploaded')
    },
    quillChanged(html, quill) {
      this.block.quill = quill
      this.block.html = html
    },
    socialChange(){
      this.block.data = this.social
    }
  },
}
</script>

<style></style>
